import UnderlineToolbarView from "./UnderlineToolbarView.vue";
import {Underline as UnderlineExtension} from "@tiptap/extension-underline";

export default class Underline {

    constructor() {
        this.toolbarView = UnderlineToolbarView;
    }

    static create() {
        return new Underline();
    }

    getExtensions() {
        return [UnderlineExtension];
    }
}